import maleNames from './assets/male-names.json'
import femaleNames from './assets/female-names.json'
import surnames from './assets/surnames.json'
import randomPictures from './assets/random-pictures.json'

import { randomId } from './utils'

// Source: https://stackoverflow.com/a/7616484
Object.defineProperty(String.prototype, 'hashCode', {
  value: function(k = 0) {
    var hash = 0, i, chr;
    for (i = 0; i < this.length; i++) {
      chr   = this.charCodeAt(i);
      hash  = ((hash << (Math.abs(k) + 5)) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }
});

export function randomSeed(male) {
  return `${male ? 1 : 0}${randomId()}`
}

export function randomArrayChoice(array, hashCode) {
  const i = Math.abs(hashCode) % array.length
  return array[i]
}

export function randomProfile(seed) {
  const male = seed[0] === '1'
  const hashCode0 = seed.hashCode()
  const hashCode4 = seed.hashCode(4)
  // 20% chance getting 2 first names
  const firstNameWordCount = ((Math.abs(hashCode0) % 6) < 5) ? 1 : 2
  const firstNameSource = male ? maleNames : femaleNames
  const firstNameWords = []

  for (let i = 0; i < firstNameWordCount; i++) {
    const word = randomArrayChoice(firstNameSource, seed.hashCode(i))
    firstNameWords.push(word)
  }

  const firstName = firstNameWords.join(' ')
  const lastName = randomArrayChoice(surnames, hashCode4)

  const profilePictureSource = [
    ...(randomPictures.profile.common || []),
    ...((male ? randomPictures.profile.male : randomPictures.profile.female) || [])
  ]
  const profilePicture = randomArrayChoice(profilePictureSource, hashCode0)

  const coverPictureSource = [
    ...(randomPictures.cover.common || []),
    ...((male ? randomPictures.cover.male : randomPictures.cover.female) || [])
  ]
  const coverPicture = randomArrayChoice(coverPictureSource, hashCode4)

  return {
    firstName,
    lastName,
    profilePicture,
    coverPicture
  }
}

export function getProfile(seed, store) {
  const generated = randomProfile(seed)
  let override = {}

  try {
    override = store.fb.profiles[`RAND_${seed}`] || {}
  } catch (e) {
    e
  }

  return {
    ...generated,
    ...override
  }
}